<template>
  <div class=" h-screen overflow-y-auto">
    <div class="my-9">
      <div class="select-box">
        <DeviceSearchSelect placeholder="請選擇機台" @change="handleChange" />
      </div>
    </div>

    <div class="container_box">
      <div class="tabs">
        <span v-for="(item, index) of fileTypeNameArr" :key="index">
          <input v-model="swPick" type="radio" :id="'radio-' + index" name="tabs" checked @change="handleTabChange(index)" />
          <label :class="{ active: swPick === item }" class="tab" :for="'radio-' + index">{{ item }}</label>
        </span>
        <span ref="glider" :class="{ glider: swPick !== null }" class="" :style="{ transform: 'translateX(' + gliderPosition + '%)' }"></span>
      </div>
    </div>

    <div>
      <div class="my-4 flex items-center justify-between">
        <div>
          <span class=" ml-5 mr-3">
            <template>
              {{ `已選擇 ${selectedRowKeys.length} 個log檔` }}
            </template>
          </span>
          <a-button @click="GetLog()" type="primary"> 取得所選log檔 </a-button>
        </div>

        <a-button class=" mr-4" type="primary" :disabled="!hasSelected" :loading="loading" @click="ClearPick"> 清除勾選 </a-button>
      </div>
      <a-table :row-key="(record) => record.name" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns="columns" :data-source="checkList" />
    </div>
  </div>
</template>

<script>
// const iconv = require('iconv-lite')
import DeviceSearchSelect from '@/components/DeviceSearchSelect.vue'

export default {
  name: 'GetLogFile',
  components: {
    DeviceSearchSelect
  },

  data () {
    return {
      loading: false,
      selectedRowKeys: [],
      fileTypeNameArr: [],
      mac: null,
      swPick: null,
      checkList: [],
      gliderPosition: 0, // Initial glider position
      columns: [
        {
          title: '檔案名稱',
          dataIndex: 'name'
        }
      ]
    }
  },
  computed: {
    hasSelected () {
      return this.selectedRowKeys.length > 0
    },
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    },
    logFilesData: {
      get () {
        return this.$store.state.logFilesData
      },
      set () {}
    }
  },
  mounted () {},
  watch: {
    logFilesData: {
      handler (newValue, oldValue) {
        const fileTypeNameArr = Object.keys(newValue || {})
        this.fileTypeNameArr = fileTypeNameArr

        if (fileTypeNameArr.length === 0) {
          this.swPick = null
          this.gliderPosition = 0
          this.checkList = []
          return
        }

        if (!this.swPick || !Array.isArray(newValue[this.swPick])) {
          this.handleTabChange(0)
        }
      },
      deep: true // 深度監聽 可以聽到物件裡的值改變
    }
  },
  methods: {
    base64ToBlob (base64Str, mime) {
      const byteCharacters = window.atob(base64Str)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: mime })
      return blob
    },
    GetLog () {
      if (this.selectedRowKeys.length < 1) return
      const files = this.selectedRowKeys.map((row) => ({
        dir: this.swPick, // 這裡的 this.swPick 應該是你的 dir 資料
        file: row
      }))
      const inf = JSON.stringify({ files: files })
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = `command/${this.mac}/getLog`
      //   message.destinationName = 'command/000732adab8b/getLog'
      this.mqttClient.send(message)
    },
    handleTabChange (index) {
      const tabName = this.fileTypeNameArr[index]
      const tabItems = this.logFilesData[tabName]

      this.swPick = tabName || null
      this.gliderPosition = index * 100 // Set glider position based on index

      if (!tabName || !Array.isArray(tabItems)) {
        this.checkList = []
        return
      }

      this.checkList = tabItems.map((item) => ({ name: item }))
      this.checkList = this.checkList.reverse()
      console.log(this.checkList)
    },
    ClearPick () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.selectedRowKeys = []
      }, 1000)
    },
    onSelectChange (selectedRowKeys) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleChange (mac) {
      this.$store.commit('logFilesData', {}) // 清掉之前的logFilesData
      this.checkList = []
      this.selectedRowKeys = []
      this.swPick = null
      this.mac = mac

      if (!mac) {
        return
      }

      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = `command/${mac}/logFiles`
      this.mqttClient.send(message)
    },
    PublishScan () {
      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = 'scan'
      this.mqttClient.send(message)
    }
  }
}
</script>

<style lang="css" scoped>
.tt {
  flex-grow: 3;
  text-align: right;
}

.ant-select {
  font-size: 20px;
  line-height: 1.5;
}

.select-box {
  width: 240px;
  margin: 0 auto;
}

.container_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.active {
  color: whitesmoke;
}
.tabs {
  display: flex;
  background-color: #fff;
  box-shadow: 0 0 1px 0 rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
  padding: 0.75rem;
  border-radius: 99px;
}

.tabs * {
  z-index: 2;
}

input[type="radio"] {
  display: none;
}

.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 150px;
  font-size: 1.25rem;
  font-weight: 500;
  border-radius: 99px;
  cursor: pointer;
  transition: color 0.15s ease-in;
}

.glider {
  position: absolute;
  display: flex;
  height: 44px;
  width: 150px;
  background-color: rgb(85, 85, 161);
  z-index: 1;
  border-radius: 99px;
  transition: 0.25s ease-out;
}
</style>
